var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7fec4ddb9924943f42c02b410de6b404.svg#0';
                    var viewUrl = 'sprites.7fec4ddb9924943f42c02b410de6b404.svg#view-0';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };